import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	// {
	//   label: 'Registre',
	//   icon: 'acies_analytics',
	//   path: 'masterdata',
	//   overlay: false,
	//   children: [],
	//   parents: ['Masterdata'],
	//   shortcut: 'control.alt.m',
	//   permission: 'insights:UserReportGet',
	//   forceTranslateKey: 'masterdata.sidebar.registers',
	// },
	{
		label: 'Symboltegninger',
		icon: 'acies_attachment',
		path: 'masterdata/registers/T_KonstSymbol',
		overlay: false,
		children: [],
		parents: ['Masterdata'],
		shortcut: 'control.alt.m',
		permission: 'drawing:SymbolGetList',
		forceTranslateKey: 'masterdata.sidebar.symbols',
	},
	{
		label: 'Length optimization',
		icon: 'acies_ruler',
		path: 'administration',
		overlay: false,
		permission: 'cutting:RackList',
		parents: ['Masterdata'],
		forceTranslateKey: 'masterdata.sidebar.optimization',
		children: [
			{
				label: 'Setups',
				icon: 'acies_setups',
				path: 'masterdata/cutting/setups',
				overlay: false,
				children: [],
				permission: 'cutting:RackList',
				parents: ['Masterdata', 'Length optimization'],
				forceTranslateKey: 'masterdata.sidebar.setups',
			},
			{
				label: 'Rules',
				icon: 'acies_rules',
				path: 'masterdata/cutting/rules',
				overlay: false,
				children: [],
				permission: 'cutting:RackList',
				parents: ['Masterdata', 'Length optimization'],
				forceTranslateKey: 'masterdata.sidebar.rules',
			},
			{
				label: 'Baskets',
				icon: 'acies_baskets',
				path: 'masterdata/cutting/baskets',
				overlay: false,
				children: [],
				permission: 'cutting:RackList',
				parents: ['Masterdata', 'Length optimization'],
				forceTranslateKey: 'masterdata.sidebar.baskets',
			},
			{
				label: 'Configs',
				icon: 'acies_configs',
				path: 'masterdata/cutting/configs',
				overlay: false,
				children: [],
				permission: 'cutting:RackList',
				parents: ['Masterdata', 'Length optimization'],
				forceTranslateKey: 'masterdata.sidebar.configs',
			},
		],
	},
	{
		label: 'Pallet optimization',
		icon: 'acies_palleting',
		path: 'administration',
		overlay: false,
		permission: 'palletising:PalletGet',
		parents: ['Masterdata'],
		forceTranslateKey: 'masterdata.sidebar.palletoptimization',
		children: [
			{
				label: 'Groupings',
				icon: 'acies_grouping',
				path: 'masterdata/palletising/groupings',
				overlay: false,
				children: [],
				permission: 'palletising:PalletDimensionGet',
				parents: ['Masterdata', 'Pallet optimization'],
				forceTranslateKey: 'masterdata.sidebar.groupings',
			},
			{
				label: 'Pallets',
				icon: 'acies_pallets',
				path: 'masterdata/palletising/pallets',
				overlay: false,
				children: [],
				permission: 'palletising:PalletDimensionGet',
				parents: ['Masterdata', 'Pallet optimization'],
				forceTranslateKey: 'masterdata.sidebar.pallets',
			},
			{
				label: 'ZipCode Rules',
				icon: 'acies_delivery_truck',
				path: 'masterdata/palletising/zipcode',
				overlay: false,
				children: [],
				permission: 'palletising:ZipCodeList',
				parents: ['Masterdata', 'Pallet optimization'],
				forceTranslateKey: 'masterdata.sidebar.zipcoderules',
			},
			{
				label: 'Configuration',
				icon: 'acies_configs',
				path: 'masterdata/palletising/configuration',
				overlay: false,
				children: [],
				permission: 'palletising:ConfigurationList',
				parents: ['Masterdata', 'Pallet optimization'],
				forceTranslateKey: 'masterdata.sidebar.configuration',
			},
		],
	},
	{
		label: 'Racking',
		icon: 'racking',
		path: 'racking',
		overlay: false,
		permission: 'racking:RackList',
		parents: ['Masterdata'],
		forceTranslateKey: 'masterdata.sidebar.racking',
		children: [
			{
				label: 'Racks',
				icon: 'acies_racks',
				path: 'masterdata/racking/racks',
				overlay: false,
				children: [],
				permission: 'racking:RackList',
				parents: ['Masterdata', 'Racking'],
				forceTranslateKey: 'masterdata.sidebar.racks',
			},
			{
				label: 'Rackset',
				icon: 'acies_racksets',
				path: 'masterdata/racking/rack-sets',
				overlay: false,
				children: [],
				permission: 'racking:RacksetList',
				parents: ['Masterdata', 'Racking'],
				forceTranslateKey: 'masterdata.racking.racksets',
			},
			{
				label: 'Rules',
				icon: 'acies_rules',
				path: 'masterdata/racking/rules',
				overlay: false,
				children: [],
				permission: 'racking:RuleList',
				parents: ['Masterdata', 'Racking'],
				forceTranslateKey: 'masterdata.sidebar.rules',
			},
		],
	},
	{
		label: 'Carting',
		icon: 'carting',
		path: 'carting',
		overlay: false,
		permission: 'carting:WagonList',
		parents: ['Masterdata'],
		forceTranslateKey: 'masterdata.sidebar.carting',
		children: [
			{
				label: 'Wagons',
				icon: 'acies_wagons',
				path: 'masterdata/carting/wagons',
				overlay: false,
				children: [],
				permission: 'carting:WagonList',
				parents: ['Masterdata', 'Carting'],
				forceTranslateKey: 'masterdata.sidebar.wagons',
			},
			{
				label: 'Config',
				icon: 'acies_configs',
				path: 'masterdata/carting/config',
				overlay: false,
				children: [],
				permission: 'carting:ConfigList',
				parents: ['Masterdata', 'Carting'],
				forceTranslateKey: 'masterdata.sidebar.configuration',
			},
		],
	},
	{
		label: 'CO2',
		icon: 'carbon_accounting',
		path: 'masterdata/co2',
		overlay: false,
		children: [],
		parents: ['Masterdata'],
		// these permissions are used by Acies One so we add one
		// mdm:AppList, mdm:StoreList, mdm:StoreGet, mdm:AppGet
		permission: 'mdm:AppList',
		forceTranslateKey: 'masterdata.sidebar.co2Data',
	},
];

export const registerNames: object = {
	T_KonstSymbol: 'masterdata.sidebar.symbols',
};
